import { apiClient } from '../../app/api/client';

import type {
  FeatureRoleMapping,
  ImportPreview,
  ProjectDocument,
} from './types';

export interface NetworkImportApi {
  applyImport(
    projectId: string,
    expectedRevision: number,
    file: File,
    mappings: FeatureRoleMapping[],
  ): Promise<ProjectDocument>;
  getProject(projectId: string): Promise<ProjectDocument>;
  previewImport(file: File): Promise<ImportPreview>;
}

async function fileToBase64(file: File): Promise<string> {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => {
      reject(new Error('The local file could not be read.'));
    };
    reader.onload = () => {
      if (typeof reader.result !== 'string') {
        reject(new Error('The local file did not produce a data URL.'));
        return;
      }
      const separator = reader.result.indexOf(',');
      if (separator < 0) {
        reject(new Error('The local file data URL was malformed.'));
        return;
      }
      resolve(reader.result.slice(separator + 1));
    };
    reader.readAsDataURL(file);
  });
}

export const networkImportApi: NetworkImportApi = {
  applyImport: async (projectId, expectedRevision, file, mappings) =>
    await apiClient.post(`/projects/${projectId}/imports`, {
      json: {
        content_base64: await fileToBase64(file),
        expected_revision: expectedRevision,
        filename: file.name,
        mappings,
      },
    }),
  getProject: async (projectId) =>
    await apiClient.get(`/projects/${projectId}`),
  previewImport: async (file) =>
    await apiClient.post('/projects/import-preview', {
      json: {
        content_base64: await fileToBase64(file),
        filename: file.name,
      },
    }),
};
